import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for P.F. Candle Co.'s "Sandalwood Rose - 7.2 oz
// Standard Candle" (p_7og6diq2), pulled from Faire's live
// `GET /api/product-reviews/product/{product_token}` endpoint — verbatim
// comment, real reviewer, real rating, real publish date.
export const review_pfc5: FaireReviewEntity = {
  token: "review_pfc5",
  type: "review",
  brandName: "P.F. Candle Co.",
  brandToken: "b_a9b3b023",
  productToken: "p_7og6diq2",
  reviewType: "product",
  reviewerName: "Haley Solar",
  reviewerLocation: "Los Angeles, CA, United States",
  stars: 5,
  reviewText:
    "Fast shipping wonderful candles! No exclusivity as a seller but who cares when you can't keep them on the shelves!",
  reviewDate: "Jul 24, 2019",
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:49:30.000Z",
    importedBy: "entity-db-cli",
  },
};
